/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Ai_Transparency_TitleInputs */

const en_impressum_ai_transparency_title = /** @type {(inputs: Impressum_Ai_Transparency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Transparency Notice`)
};

const de_impressum_ai_transparency_title = /** @type {(inputs: Impressum_Ai_Transparency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Transparenzhinweis`)
};

const fr_impressum_ai_transparency_title = /** @type {(inputs: Impressum_Ai_Transparency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avis de transparence IA`)
};

const es_impressum_ai_transparency_title = /** @type {(inputs: Impressum_Ai_Transparency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de transparencia de IA`)
};

const it_impressum_ai_transparency_title = /** @type {(inputs: Impressum_Ai_Transparency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avviso sulla trasparenza dell'AI`)
};

const nl_impressum_ai_transparency_title = /** @type {(inputs: Impressum_Ai_Transparency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparantieverklaring AI`)
};

const pl_impressum_ai_transparency_title = /** @type {(inputs: Impressum_Ai_Transparency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacja o przejrzystości AI`)
};

const fi_impressum_ai_transparency_title = /** @type {(inputs: Impressum_Ai_Transparency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoälyn läpinäkyvyysilmoitus`)
};

const da_impressum_ai_transparency_title = /** @type {(inputs: Impressum_Ai_Transparency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bemærkning om AI-gennemsigtighed`)
};

const sv_impressum_ai_transparency_title = /** @type {(inputs: Impressum_Ai_Transparency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparensinformation om AI`)
};

/**
* | output |
* | --- |
* | "AI Transparency Notice" |
*
* @param {Impressum_Ai_Transparency_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_ai_transparency_title = /** @type {((inputs?: Impressum_Ai_Transparency_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Ai_Transparency_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_ai_transparency_title(inputs)
	if (locale === "fr") return fr_impressum_ai_transparency_title(inputs)
	if (locale === "es") return es_impressum_ai_transparency_title(inputs)
	if (locale === "it") return it_impressum_ai_transparency_title(inputs)
	if (locale === "nl") return nl_impressum_ai_transparency_title(inputs)
	if (locale === "pl") return pl_impressum_ai_transparency_title(inputs)
	if (locale === "fi") return fi_impressum_ai_transparency_title(inputs)
	if (locale === "da") return da_impressum_ai_transparency_title(inputs)
	if (locale === "sv") return sv_impressum_ai_transparency_title(inputs)
	return en_impressum_ai_transparency_title(inputs)
});